import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { MenuItem, MenuGroup } from './Layout';
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  menuGroups?: MenuGroup[];
}
const DRAWER_WIDTH = 250;
const Sidebar: React.FC<SidebarProps> = ({
  isOpen,
  onClose,
  menuGroups = []
}) => {
  const location = useLocation();
  const drawerContent = <Box sx={{
    width: DRAWER_WIDTH,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#F8F9FA'
  }} data-id="element-860">
      <Box sx={{
      p: 2,
      display: {
        lg: 'none'
      },
      borderBottom: 1,
      borderColor: '#E5E7EB'
    }} data-id="element-861">
        <IconButton onClick={onClose} data-id="element-862">
          <CloseIcon data-id="element-863" />
        </IconButton>
      </Box>
      <Box sx={{
      flexGrow: 1,
      overflowY: 'auto',
      pt: 2
    }} data-id="element-864">
        <List sx={{
        px: 2
      }} data-id="element-865">
          {menuGroups.map((group, groupIndex) => <Box key={group.title} sx={{
          mb: 3
        }} data-id="element-866">
              <Typography variant="overline" sx={{
            px: 2,
            display: 'block',
            fontSize: '11px',
            fontWeight: 600,
            color: '#9CA3AF',
            letterSpacing: '0.05em',
            mb: 1
          }} data-id="element-867">
                {group.title}
              </Typography>
              {group.items.map(item => {
            const isActive = location.pathname === item.path;
            return <ListItem key={item.text} disablePadding sx={{
              mb: 0.5
            }} data-id="element-868">
                    <ListItemButton component={Link} to={item.path} onClick={onClose} sx={{
                borderRadius: 1.5,
                bgcolor: isActive ? '#F0F3F7' : 'transparent',
                borderLeft: isActive ? '3px solid #0052CC' : '3px solid transparent',
                '&:hover': {
                  bgcolor: '#F9FAFB'
                }
              }} data-id="element-869">
                      <ListItemIcon sx={{
                  minWidth: 40
                }} data-id="element-870">
                        <Box sx={{
                    color: isActive ? '#0052CC' : '#6B7280',
                    display: 'flex',
                    alignItems: 'center'
                  }} data-id="element-871">
                          {item.icon}
                        </Box>
                      </ListItemIcon>
                      <ListItemText primary={item.text} primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#0052CC' : '#374151'
                }} data-id="element-872" />
                    </ListItemButton>
                  </ListItem>;
          })}
            </Box>)}
        </List>
      </Box>
    </Box>;
  return <>
      {/* Mobile drawer */}
      <Drawer anchor="left" open={isOpen} onClose={onClose} sx={{
      display: {
        xs: 'block',
        lg: 'none'
      },
      '& .MuiDrawer-paper': {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box'
      }
    }} data-id="element-873">
        {drawerContent}
      </Drawer>
      {/* Desktop drawer */}
      <Drawer variant="permanent" sx={{
      display: {
        xs: 'none',
        lg: 'block'
      },
      width: DRAWER_WIDTH,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        width: DRAWER_WIDTH,
        boxSizing: 'border-box',
        borderRight: 1,
        borderColor: 'divider',
        position: 'relative'
      }
    }} data-id="element-874">
        {drawerContent}
      </Drawer>
    </>;
};
export default Sidebar;